import * as React from "react";
import { motion } from "framer-motion";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Link as Links } from "react-scroll";
const LI = styled(motion.li)`
  list-style: none;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const variants = {
  open: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 },
    },
  },
  closed: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 },
    },
  },
};

// const colors = ["#FF008C", "#D309E1", "#9C1AFF", "#7700FF", "#4400FF"];

export const MenuItem = ({ i, data, toggleOpen, titles, isOpen }) => {
  // const style = { border: `2px solid ${colors[i]}` };
  return (
    <LI
      variants={variants}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
    >
      <Link to={data.path} onClick={() => toggleOpen(!isOpen)}>
        {data.title}
      </Link>
      {window.location.pathname === "/" ? (
        <Links to={data.path} onClick={() => toggleOpen(!isOpen)}>
          <b style={{ color: " #1890ff", fontWeight: "500" }}>{data.titles}</b>
        </Links>
      ) : (
        ""
      )}
    </LI>
  );
};
